// MFL names (Terminus Hotel, spec § 3.4). Not verified against any other store.
export const BEER = 'Beer';
export const CIDER = 'Cider & Ginger Beer';
export const RED = 'Red Wine';
export const WHITE = 'White Wines';
export const SPARKLING = 'Champagne & Sparkling';
export const FORTIFIED = 'Fortified Wine';
export const SPIRITS = 'Spirits';
export const PREMIX = 'Premixed Drinks';

export type DepartmentJoinId = 'wine' | 'beer-cider' | 'spirits' | 'premix';

/**
 * Named client-side joins over several MFL departments (ruling RC2). The mega menu and the
 * deep-linked join screen read the same paths. Imports nothing from the menu modules.
 */
export const DEPARTMENT_JOINS: Record<DepartmentJoinId, {paths: string[][]; label: string}> = {
  wine: {paths: [[RED], [WHITE], [SPARKLING], [FORTIFIED]], label: 'Wine'},
  'beer-cider': {paths: [[BEER], [CIDER]], label: 'Beer & Cider'},
  spirits: {paths: [[SPIRITS]], label: 'Spirits'},
  premix: {paths: [[PREMIX]], label: 'Premix'},
};

export const isDepartmentJoinId = (value: string): value is DepartmentJoinId =>
  Object.prototype.hasOwnProperty.call(DEPARTMENT_JOINS, value);

export const joinTitle = (join: DepartmentJoinId, specials?: boolean): string => {
  const {label} = DEPARTMENT_JOINS[join];
  return specials ? `${label} Specials` : `Shop All ${label}`;
};
